import 'core-js/fn/array/find'
import 'core-js/fn/array/from'
import 'core-js/fn/object/entries'



// WEBPACK FOOTER //
// ./src/polyfills.js